import i18n from "vue-i18n"

export default {
	name: "FooterBlock",
	data() {
		return {
			headerOpen: false,
			isReady: false,
			content: null,
			language: this.$route.params.lang
		}
	},
	props: [
		"credits",
	],
	created() {
		this.getContent();
	},
	watch: {
		"$route": function() {
			this.language = this.$route.params.lang
		}
	},
	methods: {
		getContent() {
			getLocationsList().then(
				content => {
					this.content = content;
					this.isReady = true;
				}
			);
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/footer/footer.block.js